import Helper from '@/helpers/helper'

/**
 * Navigation Guard
 * This will check or run function every route or navigating
 * @param {Object} to  
 * @param {Object} from  
 * @param {function} next  
 * @param {Object} store
 */
export default function navguard ({to, from, next, store}) {
    const isonline = store.state.isonline;
    /**
     * Get route from and save to store 
     */
    store.commit('updateroutefrom', from);
    /**
     * Check if has session or expired 
     * if expired delete cookie token
     */

    /**
     * Logout function
     */
    const logout = () => {
        store.commit('updateloginstatus', false);
        Helper.deleteCookie('holesadmintoken');


        if(to.name != 'login') {
            next({name : 'login'}); 
        } else {
            next();
        }
    }
    /**
     * Check session
     */
    Helper.checksession()
        .then((res) => {
            store.commit('updateloginstatus', true);

            /**
             * Update user store
             * check if logged in user is admin or employee 
             * check router is for admin only 
             */
             if(res.success) {
                const user = res.data
                store.commit('updateuser', user);
                
                /**
                 * If trying to access login page
                 * redirect to default page base on account type
                 */

                switch (to.name) {
                    case 'login':
                        if(user.roles.includes('super-admin') || user.roles.includes('manager')) {
                            next({name : 'deliveries'}); 
                        } else if(user.roles.includes('driver')) {
                            next({name : 'employeeDeliveries'}); 
                        } else {
                            logout();
                        }
                        break;
                
                    default:
                        /**
                         * Check account type and router type
                         * @example if account type is employee route should be employee 
                         */
                        if(user.roles.includes('driver')) {
                            /**
                             * Employees routes only
                             */
                            if(to.meta.type.includes('driver')) {
                                next();
                            } else {
                                next({name : 'employeeDeliveries'}); 
                            }
                        } else if(user.roles.includes('manager')) {
                            /**
                             * Manager routes only
                             */
                            if(to.meta.type.includes('manager')) {
                                next();
                            } else {
                                next({name : 'deliveries'}); 
                            }
                        } else if(user.roles.includes('super-admin')) {
                            /**
                             * All access for admin
                             */
                            next();
                        } else {
                            logout()
                        }
                        break;
                }
               
            } else {
                logout()
            }

            
        })
        .catch(() => {
            if(isonline) {
                store.commit('updateloginstatus', false);
                Helper.deleteCookie('holesadmintoken');
                
                switch (to.name) {
                    case 'login':
                        next();
                        break;

                    case 'forgotpassword':
                        next();
                        break;
                    
                    case 'resetpassword':
                        next();
                        break;
                
                    default:
                        next({name : 'login'}); 
                        break;
                }
            }
        })

    

}